<template>
  <v-main>
    <div class="flex min-h-full items-center justify-center px-4 py-6">
      <div class="flex w-full max-w-md flex-col items-center gap-8 text-center">
        <AircapLogo size="50px" />

        <ErrorStatus v-if="failed">{{ t("open.errorOccurred") }}</ErrorStatus>

        <template v-else>
          <v-progress-circular indeterminate color="primary" size="56" width="4" />
          <div class="flex flex-col gap-2">
            <div class="text-xl font-bold">{{ t(openAction?.message ?? "open.title") }}</div>
            <div class="text-sm text-medium-emphasis">{{ t("open.redirecting") }}</div>
          </div>
        </template>
      </div>
    </div>
  </v-main>
</template>

<script lang="ts" setup>
import AircapLogo from "@/components/AircapLogo.vue";
import ErrorStatus from "@/components/ErrorStatus.vue";
import { useI18n } from "@/composables/useI18n";
import { openActions } from "@/composables/useOpenInNewTab";
import { captureException } from "@sentry/vue";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";

const { t } = useI18n();
const route = useRoute();

const failed = ref(false);
const openAction = Object.entries(openActions).find(([name]) => name === route.params.action)?.[1];

onMounted(async () => {
  try {
    if (!openAction) throw new Error("Unknown open action");
    const url = await openAction.resolveUrl((key) => {
      const value = route.query[key];
      if (typeof value !== "string") throw new Error(`Missing ${key} query`);
      return value;
    });
    if (!url) throw new Error("Empty URL");
    window.location.replace(url);
  } catch (cause) {
    const error = new Error(`Error opening ${route.fullPath}`, { cause });
    console.error(error);
    captureException(error);
    failed.value = true;
  }
});
</script>
